var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSberLogoFffColor(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 22 22",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.69 4.29C20.21 4.96 20.66 5.69 21.01 6.48L10.99 13.87L6.8 11.24V8.08L10.99 10.71L19.69 4.3V4.29ZM10.99 0.0100002C13.61 0.0100002 16.01 0.92 17.9 2.45L15.76 4.03C14.4 3.1 12.76 2.55 10.99 2.55C6.33 2.55 2.53 6.35 2.53 11.01C2.53 15.67 6.32 19.47 10.99 19.47C15.66 19.47 19.45 15.68 19.45 11.01C19.45 10.93 19.45 10.86 19.45 10.78L21.82 9.03C21.94 9.67 22 10.33 22 11C22 17.07 17.07 22 11 22C4.93 22 0 17.08 0 11C0 4.92 4.93 0 11 0L10.99 0.0100002Z",
    fill: "#fff"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSberLogoFffColor);
export default __webpack_public_path__ + "static/media/sber_logo_fff_color.df84bef85f3c75b6ad6b326db1b7d117.svg";
export { ForwardRef as ReactComponent };